export const REVIEW_AUTOMATION_ACTIVATED = 'Review Automation Activated'

export const REVIEW_REQUEST_DELAY_UPDATED =
  'Review Automation & Request Delay Updated'
